import { type PropsWithChildren } from 'react';

import { createPortal } from 'react-dom';

export default function Teleport({ children }: PropsWithChildren) {
	return createPortal(children, document.getElementById('root') as HTMLElement);
}
